import { ArrowRight } from "lucide-react";
import IMAGES from "../data/imageMap";
import { useSiteContent } from "../contexts/SiteContent";

export default function CtaBanner() {
  const { t } = useSiteContent();
  return (
    <section id="science-for-all" data-testid="cta-banner" className="bg-white py-12 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="relative overflow-hidden rounded-[24px] min-h-[280px] md:min-h-[360px] flex items-center">
          <img src={IMAGES.cta} alt="" className="absolute inset-0 w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-white/95 via-white/70 to-white/20" />
          <div className="relative w-full p-8 md:p-14 max-w-[680px]">
            <p className="text-[12px] uppercase tracking-[0.18em] font-medium text-[#2d5fd4]">
              {t("cta_banner.eyebrow", "Introducing")}
            </p>
            <h2 className="mt-3 text-[26px] md:text-[40px] font-semibold tracking-[-0.02em] leading-[1.1] text-neutral-900">
              {t(
                "cta_banner.headline",
                "Accelerate your research with AI tools and resources built to support scientific endeavors."
              )}
            </h2>
            <a
              href="#resources"
              data-testid="cta-banner-button"
              className="mt-7 inline-flex items-center gap-2 rounded-full bg-neutral-900 px-6 h-11 text-[14px] font-medium text-white transition-all hover:bg-neutral-800 hover:gap-3"
            >
              {t("cta_banner.cta_label", "Learn more")}
              <ArrowRight className="h-4 w-4" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
